import React from 'react';
import { useTranslation } from 'react-i18next';
import { select } from '@panel/commons/core/themev2';
import { Icon } from '@panel/commons';
import { formatAmount } from '@panel/commons/helpers/formatAmount';
import { site } from '@panel/commons/helpers';
import {
  PreviewContainer,
  PostingImageWrapper,
  PostingInfoWrapper,
  BlockInfo,
  Pill,
  AddressContainer,
  Rates,
  AddressBox,
  FeaturesBox,
  PostingTitle,
  PostingDescription,
  PublisherInfo
} from './styles';

const siteId = site.id;

function PreviewDesktop({ planInfo, postingPreview }) {
  const {
    address,
    description,
    features,
    location,
    prices,
    realEstateName,
    title,
    urlLogo,
    urlPicture
  } = postingPreview;
  const { t } = useTranslation();

  return (
    <PreviewContainer data-repa='step3mod3-container'>
      <PostingImageWrapper data-repa='step3mod3-container-imgWrapper'>
        <img data-repa='step3mod3-container-img' src={urlPicture} alt={title} />
      </PostingImageWrapper>
      <PostingInfoWrapper minWidth data-repa='step3mod3-container-infoWrapper'>
        <div>
          <BlockInfo layout='row' data-repa='step3mod3-container-blockInfo1'>
            <Rates data-repa='step3mod3-info-rates'>
              <h2 data-repa='step3mod3-info-rates-amount'>{formatAmount(prices[0].amount, prices[0].currency)}</h2>
              <p data-repa='step3mod3-info-rates-expenses'>
                {features.CFT6 &&
                  `+ ${formatAmount(features.CFT6.value, null, true)}${t('publisher.step4.module3.preview.expenses')}`}
              </p>
            </Rates>
            <AddressContainer data-repa='step3mod3-info-address'>
              <AddressBox data-repa='step3mod3-info-address-container' plan={planInfo.highlight.toUpperCase()}>
                <h2 data-repa='step3mod3-info-address-label'>{address}</h2>
                <p data-repa='step3mod3-info-address-location'>{location}</p>
              </AddressBox>
              <Pill
                data-repa='step3mod3-info-address-pill'
                top='15'
                right='15'
                color='midDarkGray'
                borderColor='midDarkGray'
                className={planInfo.highlight.toUpperCase()}
              >
                {planInfo.name}
              </Pill>
            </AddressContainer>
          </BlockInfo>
          <BlockInfo layout='column' data-repa='step3mod3-container-blockInfo2'>
            <FeaturesBox data-repa='step3mod3-container-blockInfo2-features'>
              {features.CFT100 && (
                <div>
                  <Icon
                    data-repa='step3mod3-container-blockInfo2-features100'
                    name='meters'
                    width={16}
                    height={17}
                    viewBox='0 0 16 17'
                    colorFill={select('midDarkGray')}
                  />
                  <span data-repa='step3mod3-container-blockInfo2-features100-span'>{`${features.CFT100.value} ${features.CFT100.value_unit}`}</span>
                </div>
              )}
              {!features.CFT100 && features.CFT101 && (
                <div>
                  <Icon
                    data-repa='step3mod3-container-blockInfo2-features101'
                    name='meters'
                    width={16}
                    height={17}
                    viewBox='0 0 16 17'
                    colorFill={select('midDarkGray')}
                  />
                  <span data-repa='step3mod3-container-blockInfo2-features101-span'>{`${features.CFT101.value} ${features.CFT101.value_unit}`}</span>
                </div>
              )}
              {siteId === 'ZPAR' && features.CFT1 && (
                <div>
                  <Icon
                    data-repa='step3mod3-container-blockInfo2-features1'
                    name='dorms'
                    width={16}
                    height={17}
                    viewBox='0 0 16 17'
                    colorFill={select('midDarkGray')}
                  />
                  <span data-repa='step3mod3-container-blockInfo2-features1-span'>
                    {features.CFT1.value} {t('publisher.step4.module3.preview.features2')}
                  </span>
                </div>
              )}
              {siteId !== 'ZPAR' && features.CFT2 && (
                <div>
                  <Icon
                    data-repa='step3mod3-container-blockInfo2-features2'
                    name='dorms'
                    width={16}
                    height={17}
                    viewBox='0 0 16 17'
                    colorFill={select('midDarkGray')}
                  />
                  <span data-repa='step3mod3-container-blockInfo2-features2-span'>
                    {features.CFT2.value} {t('publisher.step4.module3.preview.features2')}
                  </span>
                </div>
              )}
              {features.CFT3 && (
                <div>
                  <Icon
                    data-repa='step3mod3-container-blockInfo2-features3'
                    name='toilets'
                    width={16}
                    height={17}
                    viewBox='0 0 16 17'
                    colorFill={select('midDarkGray')}
                  />
                  <span data-repa='step3mod3-container-blockInfo2-features3-span'>
                    {features.CFT3.value} {t('publisher.step4.module3.preview.features3')}
                  </span>
                </div>
              )}
              <div>
                <Icon
                  data-repa='step3mod3-container-blockInfo2-features-garage'
                  name='garage'
                  width={16}
                  height={17}
                  viewBox='0 0 16 17'
                  colorFill={select('midDarkGray')}
                />
                <span data-repa='step3mod3-container-blockInfo2-features-garage-span'>
                  {features.CFT7
                    ? `${features.CFT7.value}  ${t('publisher.step4.module3.preview.features4')}`
                    : t('publisher.step4.module3.preview.features4b')}
                </span>
              </div>
            </FeaturesBox>
            <PostingTitle data-repa='step3mod3-postingTitle'>{title}</PostingTitle>
            <PostingDescription data-repa='step3mod3-PostingDesc'>{description}...</PostingDescription>
          </BlockInfo>
          {false && ( // Agregar logica inmobiliaria para mostrar esto
            <BlockInfo layout='row'>
              <PublisherInfo data-repa='step3mod3-publisherInfo'>
                <img
                  data-repa='step3mod3-publisherInfo-img'
                  src={urlLogo}
                  alt=''
                  onError={e => {
                    e.target.style.display = 'none';
                    return null;
                  }}
                />
                <span>{realEstateName}</span>
              </PublisherInfo>
            </BlockInfo>
          )}
        </div>
      </PostingInfoWrapper>
    </PreviewContainer>
  );
}

export { PreviewDesktop };
